import type { KeyboardEvent } from 'react';

export const preventFormSubmitOnEnterKeyPress = (event: KeyboardEvent<HTMLElement>) => {
	event.key === 'Enter' && event.preventDefault();
};
